export default "__VITE_ASSET__C8zJGPac__";